import { useEffect } from "react";

import { useGetPharmacyLazyQuery } from "~/graphql";
import { getNode } from "~/graphql/utility";

export const useFetchPharmacy = (id?: string) => {
  const [getPharmacy, { loading, data, error }] = useGetPharmacyLazyQuery();

  const pharmacy = getNode(data, "PublicOrganization");

  useEffect(() => {
    if (id) {
      getPharmacy({
        variables: {
          id,
        },
      });
    }
  }, [getPharmacy, id]);

  return { hasError: !!error, loading, pharmacy };
};
